// extracted by mini-css-extract-plugin
export default {"error":"Error_error__vSH3L","content":"Error_content__TkGre","image":"Error_image__kazvI","title":"Error_title__oONfw","text":"Error_text__CN554","buttons":"Error_buttons__gLugK"};